import React from "react";
import { connect } from "react-redux";
import l10n from "../../../../localization";
import { Row, Col } from "reactstrap";
import * as Styled from "./GraphList.styles";
import LineGraph from "../../../../components/LineGraph";

const GraphList = ({
  meters,
  meterSiteCode,
  meterCode,
  startDate,
  endDate,
}) => {
  let filteredMeters = meters.result;

  if (meterSiteCode !== "all") {
    filteredMeters = meters.result.filter(
      (meter) => meter.meterSiteCode === meterSiteCode
    );
  }

  const renderUserMeters = (meter) => {
    if (meterCode !== "all") {
      return [
        ...meter.userMeters.filter(
          (userMeter) => userMeter.meterCode === meterCode
        ),
      ];
    } else {
      return [...meter.userMeters];
    }
  };

  return (
    <Row>
      {filteredMeters.map((meter) => {
        return renderUserMeters(meter).map((userMeter, userMeterIndex) => {
          return (
            <Col key={`${userMeter.meterCode}_${userMeterIndex}`} md="4">
              <Styled.Card>
                <Styled.CardHeader>
                  <Styled.HeaderData>
                    <Styled.HeaderText>
                      {meter.siteAddress || ""}
                    </Styled.HeaderText>
                    <Styled.HeaderText>{`${l10n.graphList.meter} ${
                      userMeter.meterCode || ""
                    }`}</Styled.HeaderText>
                  </Styled.HeaderData>
                  <Styled.HeaderLegend>
                    <Styled.HeaderLegendText>
                      {l10n.graphList.consumption}
                    </Styled.HeaderLegendText>
                  </Styled.HeaderLegend>
                </Styled.CardHeader>
                <Styled.MeterData>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.mainMeterType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {meter.meterType || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.type || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterManufacturer}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.manufacturer || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterDiameter}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.diameter || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterNValve}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.nValve
                        ? l10n.reports.meterYes
                        : l10n.reports.meterNo}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem>
                    <Styled.MeterDataKey>
                      {l10n.reports.meterReadingType}
                    </Styled.MeterDataKey>
                    <Styled.MeterDataValue>
                      {userMeter.readingType || ""}
                    </Styled.MeterDataValue>
                  </Styled.MeterDataItem>
                  <Styled.MeterDataItem />
                </Styled.MeterData>
                <Styled.CardChart>
                  <LineGraph
                    startDate={startDate}
                    endDate={endDate}
                    meters={meters}
                    meterSiteCode={meter.meterSiteCode}
                    meterCode={userMeter.meterCode}
                  />
                </Styled.CardChart>
              </Styled.Card>
            </Col>
          );
        });
      })}
    </Row>
  );
};

export default connect(({ meters }) => ({ meters }), null)(GraphList);
